import React, { useRef, useState, useEffect } from 'react';

import {IFrameInsert} from "_components/IFrameInsert/IFrameInsert";
import {Countdowner} from "_components/Countdowner/Countdowner";
import {PromocracyLogo} from "_components/PromocracyLogo/PromocracyLogo";

export const UniversalComponents = props => {

    return (

        <React.Fragment>

            <Countdowner
                promotion={props.promotion}
                configKey={props.configKey}
            />

            <PromocracyLogo
                promotion={props.promotion}
            />

            <IFrameInsert
                promotion={props.promotion}
                configKey={props.configKey}
            />

        </React.Fragment>

    );
}